module.exports = __webpack_public_path__ + "img/ring_r_i_1_null.e8728b67.png";